import { useState } from "react";

export default function SelectorAnioMes({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  // ---- Año/Mes actual ----
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
  const defaultYearMonth = `${currentYear}_${currentMonth}`;

  const [anio_Mes, setanio_Mes] = useState(defaultYearMonth);

  // ---- Lista de años (últimos 5) ----
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  // ---- Meses human-readable ----
  const months = [
    { value: "01", label: "Enero" },
    { value: "02", label: "Febrero" },
    { value: "03", label: "Marzo" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  // ---- Handler ----
  const handleChange = (year: string, month: string) => {
    setanio_Mes(`${year}_${month}`);
    onChange(`${year}_${month}`);
    
  };

  
  // ---- Extraer año/mes actual ----
  const [anio, mes] = value.split("_");

  return (
    <div className="flex gap-3 items-center bg-white p-4 rounded-xl shadow-md border border-gray-200 w-fit">
      {/* Año */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-gray-600 mb-1">
          Año
        </label>
        <select
          value={anio}
          onChange={(e) => handleChange(e.target.value, mes)}
          className="border border-gray-300 rounded-lg px-3 py-2 bg-white shadow-sm focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition"
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {/* Mes */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-gray-600 mb-1">
          Mes
        </label>
        <select
          value={mes}
          onChange={(e) => handleChange(anio, e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 bg-white shadow-sm focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition"
        >
          {months.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
